import { MoneyDirection } from "@common/constants";
import { AccountClass } from "@common/constants/domains/accounting/accounts";
import { FiltersTypes } from "@common/types/filters/general";

/**
 * Default matching criteria for the built-in Directory "1099 review" views
 * and for a new Form 1099 close-template task. Templates stay
 * workspace-agnostic by using `accountClasses` instead of `coaAccounts`.
 */
export const DEFAULT_FORM_1099_REVIEW_FILTERS: FiltersTypes = {
    isEligible1099: false,
    minAmount: 2000,
    direction: MoneyDirection.MONEY_OUT,
    shouldExcludeCreditCardJournalEntries: true,
    shouldExcludePaymentProcessorJournalEntries: true,
    includeExcludedAmounts: false,
    accountClasses: [AccountClass.expenses],
};
